<template>
  <div class="authResultBody">
    <Header />
    <div class="authResultMain">
      <Step v-if="isPersonAuth == 1 && !step" :num='3' />
      <Step v-if="isPersonAuth == 1 && step" :num='4' />
      <Step v-if="isPersonAuth == 0 && !step" :num='5' authType="1" />
      <Step v-if="isPersonAuth == 0 && step" :num='6' authType="1" />
      <div v-if="!step" class="authenticationResult">
        <img src="@/assets/image/success.png">
        <h2>认证成功</h2>
        <h5 v-if="isPersonAuth == 1">恭喜您，已通过个人实名认证，完成授权</h5>
        <h5 v-if="isPersonAuth == 0">恭喜您，已通过企业实名认证</h5>
        <el-button v-if="canIssueCert" disabled type="primary" size="small">下证中（{{ time }}s）</el-button>
        <el-button v-if="!canIssueCert" type="primary" size="small" @click="getReturn">完成认证</el-button>
      </div>
      <div v-loading="loading" v-if="step&&!certInfoShow" class="authenticationResult">
        <img src="@/assets/image/fail.png">
        <h3 v-if="!certInfoShow">证书生成失败</h3>
        <el-button v-if="!certInfoShow" type="primary" size="small" @click="getIssue">生成证书</el-button>
      </div>
      <div class="certBox" v-show="step&&certInfoShow" v-loading="loading">
        <!-- <h2 class="title">证书持有人实名认证</h2> -->
        <div class="certMain">
          <h3 v-if="isPersonAuth == 1">认证成功，已经生成个人证书</h3>
          <h3 v-if="isPersonAuth == 0">认证成功，已经生成机构证书</h3>
          <div class="certItemBox">
            <div class="itemTitle">证书信息</div>
            <div class="itemBox">
              <div class="item"><span>证书序列号：</span>
                <p>{{ certInfo.signCertSn }}</p>
              </div>
              <div class="item"><span>证书类型：</span>
                <p>{{ certInfo.certType | getCertType }}</p>
              </div>
              <div class="item"><span>证书有效期：</span>
                <p>{{ certInfo.duration / 365 }}年</p>
              </div>
              <!-- <div class="item"><span>是否自动续期：</span><p>{{ certInfo.autoPostpone ? '是': '否'}}</p></div> -->
              <!-- <div class="item"><span>名称/CN：</span><p :title="certInfo.commonName">{{ certInfo.commonName }}</p></div> -->
              <div v-if="isPersonAuth == 0" class="item"><span>机构名称/O：</span>
                <p :title="certInfo.companyName">{{ certInfo.companyName }}</p>
              </div>
              <div v-if="isPersonAuth == 0" class="item"><span>社会统一信用代码：</span>
                <p :title="certInfo.licenseNo">{{ certInfo.licenseNo }}</p>
              </div>
              <div v-if="isPersonAuth == 0" class="item"><span>法定代表人：</span>
                <p :title="certInfo.legalPersonName">{{ certInfo.legalPersonName }}</p>
              </div>
              <div v-if="isPersonAuth == 0" class="item"><span>法定代表人证件号码：</span>
                <p>{{ certInfo.legalPersonIdentNo }}</p>
              </div>
              <div v-if="isPersonAuth == 1" class="item"><span>姓名/CN：</span>
                <p :title="certInfo.personName">{{ certInfo.personName }}</p>
              </div>
              <div v-if="isPersonAuth == 1" class="item"><span>证件类型：</span>
                <p>{{ certInfo.identType|IdentType }}</p>
              </div>
              <div v-if="isPersonAuth == 1" class="item"><span>证件号码：</span>
                <p>{{ certInfo.identNo }}</p>
              </div>
              <div v-if="isPersonAuth == 1 && certInfo.mobile" class="item"><span>手机号：</span>
                <p>{{ certInfo.mobile }}</p>
              </div>
            </div>
            <div class="certBoxBtn">
              <!-- <el-button type="primary" @click="getRoute" size="small">查看详细信息</el-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCertType, IdentType } from '@/utils/typeMatch'
export default {
  data() {
    return {
      loading: false,
      msg: '',
      time: 3,
      intervals: [],
      step: false,
      canIssueCert: this.$store.state.userInfo.canIssueCert,
      isPersonAuth: this.$store.state.userInfo.isPersonAuth,
      certInfoShow: false,
      certInfo: {}
    }
  },
  mounted() {
    if (this.canIssueCert) {
      this.getIssue()
      this.intervals.push(
        setInterval(() => {
          this.time--
          if (this.time == 0) {
            this.clearInterval()
            this.step = true
          }
        }, 1000)
      )
    }
  },
  filters: {
    getCertType,
    IdentType
  },
  methods: {
    getReturn() {
      window.location.href = this.$store.state.userInfo.preWebUrl
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    },
    getIssue() {
      this.loading = true
      this.$api
        .getIssue({
          flowId: this.$store.state.userInfo.flowId
        })
        .then(res => {
          if (res.code === '0') {
            this.loading = false
            this.certInfoShow = true
            this.certInfo = res.data
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.certInfoShow = false
          this.$alert(err.msg, '提示', {
            confirmButtonText: '好的',
            callback: () => {}
          })
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.authResultBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.authResultMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.authenticationResult {
  width: max-content;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 120px;
    margin-top: 52px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
    margin-top: 18px;
  }
  h3 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
    margin: 18px 0 30px;
  }
  h5 {
    margin: 8px 0 32px;
    font-size: 14px;
    color: #929292;
    line-height: 22px;
    font-weight: normal;
  }
  dl {
    width: 450px;
    background: #f1f5ff;
    border-radius: 4px;
    padding: 16px;
    margin: 32px 0;
  }
  dt {
    padding-left: 24px;
    background: url('~@/assets/image/warning.png') no-repeat;
    background-size: 16px;
    font-size: 14px;
    color: #333333;
    line-height: 19px;
    font-weight: bold;
  }
  dd {
    margin-top: 12px;
    font-size: 14px;
    color: #595959;
    line-height: 16px;
  }
  .is-disabled {
    background-color: #1c67f3;
    background-color: var(--main-bg-color);
    border-color: #1c67f3;
    border-color: var(--main-bg-color);
    opacity: 0.4;
    border-radius: 4px;
  }
}
.certBox {
  height: 100%;
  // overflow: scroll;
  background-color: #fff;
  .title {
    height: 50px;
    border: 1px solid #eceff3;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 50px;
    padding-left: 40px;
    position: relative;
    &::before {
      content: '';
      width: 2px;
      height: 14px;
      background: #4673fd;
      position: absolute;
      top: 19px;
      left: 32px;
    }
  }
  .certMain {
    min-height: 730px;
    padding-top: 210px;
    background: url('../assets/image/success.png') no-repeat center 64px;
    background-size: 120px 127px;
    text-align: center;
    h3 {
      margin: 0px 0 32px;
      font-weight: bold;
      color: #333333;
      line-height: 27px;
      font-size: 20px;
    }
    .certItemBox {
      width: 740px;
      height: 257px;
      margin: 0 auto;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 24px 0px 0 0;
    }
    .itemTitle {
      font-size: 14px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      padding-bottom: 24px;
      padding-left: 32px;
    }
    .itemBox {
      display: flex;
      flex-wrap: wrap;
      justify-items: center;
    }
    .item {
      width: 50%;
      padding: 0 32px 24px 32px;
      color: #909399;
      font-size: 14px;
      text-align: left;
      display: flex;
      overflow: hidden; //超出的文本隐藏
      white-space: nowrap; // 默认不换行；
      p {
        white-space: nowrap; // 默认不换行；
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        display: inline-block;
        color: #333;
      }
    }
    .certBoxBtn {
      padding-top: 70px;
    }
  }
}
</style>